export interface PlatformJwtClaims {
  sub: string;
  email: string;
  full_name: string;
  platform_role: string;
  platform_permissions?: string[];
  session_id?: string;
  exp: number;
  iat?: number;
}

export function decodeJwt(token: string): PlatformJwtClaims | null {
  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as PlatformJwtClaims;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string, leewaySeconds = 0): boolean {
  const claims = decodeJwt(token);
  if (!claims?.exp) return true;
  const now = Math.floor(Date.now() / 1000);
  return claims.exp - leewaySeconds <= now;
}
